<template>
  <div class="personal-center-container">
    <div class="personal-center-content">
      <div class="user-header">
        <div class="avatar-wrapper">
          <el-avatar :size="72" :src="avatar">
            <i class="el-icon-user-solid" />
          </el-avatar>
        </div>
        <div class="user-info">
          <div class="user-name">{{ userInfo.realName }}</div>
          <div class="user-account">{{ userInfo.username }}</div>
        </div>
      </div>

      <div class="info-section">
        <div class="section-header">
          <i class="el-icon-user" />
          <span>{{ $t('login.basicInfo') }}</span>
        </div>
        <div class="info-list">
          <div class="info-item">
            <span class="info-label">{{ $t('login.username') }}</span>
            <span class="info-value">{{ userInfo.username || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">{{ $t('login.realName') }}</span>
            <span class="info-value">{{ userInfo.realName || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">{{ $t('login.phone') }}</span>
            <span class="info-value">{{ userInfo.phone || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">{{ $t('login.email') }}</span>
            <span class="info-value">{{ userInfo.email || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">{{ $t('login.orgName') }}</span>
            <span class="info-value">{{ userInfo.orgName || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">{{ $t('login.siteName') }}</span>
            <span class="info-value">{{ userInfo.siteName || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">{{ $t('login.cpf') }}</span>
            <span class="info-value">{{ userInfo.cpf || '-' }}</span>
          </div>
        </div>
      </div>

      <div class="feishu-section">
        <div class="section-header">
          <i class="el-icon-link" />
          <span>{{ $t('login.feishuStatus') }}</span>
        </div>
        <div v-if="userInfo.fsUserId" class="feishu-card bound">
          <div class="feishu-icon">
            <i class="el-icon-circle-check" />
          </div>
          <div class="feishu-info">
            <div class="feishu-title">{{ $t('login.feishuBound') }}</div>
            <div class="feishu-desc">{{ $t('login.feishuBoundDesc') }}</div>
          </div>
          <el-button
            type="danger"
            size="small"
            class="unbind-btn"
            @click="showUnbindDialog"
          >
            {{ $t('login.unbindFeishu') }}
          </el-button>
        </div>
        <div v-else class="feishu-card unbound">
          <div class="feishu-icon">
            <i class="el-icon-circle-close" />
          </div>
          <div class="feishu-info">
            <div class="feishu-title">{{ $t('login.feishuNotBound') }}</div>
            <div class="feishu-desc">{{ $t('login.feishuNotBoundDesc') }}</div>
          </div>
          <el-button
            type="primary"
            size="small"
            class="bind-btn"
            @click="handleBindFeishu"
          >
            {{ $t('login.bindFeishu') }}
          </el-button>
        </div>
      </div>
    </div>

    <!-- 解绑飞书弹窗 -->
    <el-dialog
      :title="$t('login.unbindFeishu')"
      :visible.sync="unbindDialogVisible"
      width="480px"
      :close-on-click-modal="false"
      custom-class="unbind-dialog"
    >
      <div class="unbind-dialog-content">
        <div class="unbind-warning">
          <i class="el-icon-warning-outline" />
          <span>{{ $t('login.unbindWarning') }}</span>
        </div>

        <el-form
          ref="unbindFormRef"
          :model="unbindForm"
          :rules="unbindRules"
          label-position="top"
          size="medium"
        >
          <el-form-item :label="$t('login.validaCode')" prop="validaCode">
            <el-input
              v-model="unbindForm.validaCode"
              :placeholder="$t('login.inputValidaCode')"
              maxlength="6"
              clearable
              class="code-input"
            >
              <el-button
                slot="append"
                :disabled="countdown > 0"
                :loading="sendCodeLoading"
                class="send-code-btn"
                @click="sendValidaCode"
              >
                {{ countdown > 0 ? `${countdown}s` : $t('login.sendCode') }}
              </el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="unbindDialogVisible = false">
          {{ $t('GlobalSetObj.No') }}
        </el-button>
        <el-button
          type="primary"
          class="confirm-btn"
          :loading="unbindLoading"
          @click="handleUnbindFeishu"
        >
          {{ $t('GlobalSetObj.yes') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getPersonalCenter, bindFeishu, unbindFeishu, sendValidaCode } from '@/api/user';

export default {
  name: 'PersonalCenter',
  data() {
    return {
      userInfo: {
        username: '',
        realName: '',
        phone: '',
        email: '',
        positionName: '',
        fsUserId: '',
        orgName: '',
        siteName: '',
        cpf: ''
      },
      unbindDialogVisible: false,
      unbindForm: {
        validaCode: ''
      },
      unbindRules: {
        validaCode: [
          { required: true, message: this.$t('login.inputValidaCode'), trigger: 'blur' },
          { len: 6, message: this.$t('login.codeLengthError'), trigger: 'blur' }
        ]
      },
      unbindLoading: false,
      sendCodeLoading: false,
      countdown: 0,
      countdownTimer: null,
      authPopup: null,
      popupCheckTimer: null,
      messageHandler: null
    };
  },
  computed: {
    userId() {
      return this.$store.getters.userId;
    },
    avatar() {
      return this.$store.getters.avatar;
    }
  },
  created() {
    this.loadUserInfo();
  },
  beforeDestroy() {
    this.clearCountdown();
    this.clearPopupCheck();
    this.removeMessageListener();
  },
  methods: {
    // 加载用户信息
    loadUserInfo() {
      getPersonalCenter()
        .then((response) => {
          if (response.code === 200) {
            this.userInfo = {
              username: response.data.username || '',
              realName: response.data.realName || '',
              phone: response.data.phone || '',
              email: response.data.email || '',
              positionName: response.data.positionName || '',
              fsUserId: response.data.fsUserId || '',
              orgName: response.data.orgName || '',
              siteName: response.data.siteName || '',
              cpf: response.data.cpf || ''
            };
          } else {
            this.$message.error(response.msg || '获取用户信息失败');
          }
        })
        .catch((error) => {
          console.error('获取用户信息失败:', error);
          this.$message.error(this.$t('login.getUserInfoFailed'));
        });
    },

    // 绑定飞书
    handleBindFeishu() {
      const appId = process.env.VUE_APP_FEISHU_APP_ID;
      if (!appId) {
        this.$message.error(this.$t('login.feishuAppIdNotConfig'));
        return;
      }
      const redirectUri = encodeURIComponent(window.location.origin + '/feishu/callback');
      const state = encodeURIComponent('bind');
      const authUrl = `https://accounts.feishu.cn/open-apis/authen/v1/authorize?client_id=${appId}&redirect_uri=${redirectUri}&state=${state}`;

      this.authPopup = window.open(
        authUrl,
        'feishu_auth',
        'width=900,height=700,scrollbars=yes,resizable=yes,menubar=no,toolbar=no,location=no,status=no'
      );

      if (!this.authPopup) {
        this.$message.error(this.$t('login.popupBlocked'));
        return;
      }

      this.startPopupCheck();
      this.setupMessageListener();
    },

    // 显示解绑弹窗
    showUnbindDialog() {
      this.unbindDialogVisible = true;
      this.unbindForm.validaCode = '';
    },

    // 发送验证码
    async sendValidaCode() {
      this.sendCodeLoading = true;
      try {
        const res = await sendValidaCode();
        if (res.code === 200) {
          this.$message.success(this.$t('login.sendCodeSuccess'));
          this.startCountdown();
        } else {
          this.$message.error(res.msg || this.$t('login.sendCodeFailed'));
        }
      } catch (error) {
        console.error('发送验证码失败:', error);
        this.$message.error(this.$t('login.sendCodeFailed'));
      } finally {
        this.sendCodeLoading = false;
      }
    },

    // 开始倒计时
    startCountdown() {
      this.countdown = 60;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.clearCountdown();
        }
      }, 1000);
    },

    // 清除倒计时
    clearCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
        this.countdown = 0;
      }
    },

    // 开始监听弹窗
    startPopupCheck() {
      if (this.popupCheckTimer) {
        clearInterval(this.popupCheckTimer);
        this.popupCheckTimer = null;
      }
      this.popupCheckTimer = setInterval(() => {
        if (!this.authPopup || this.authPopup.closed) {
          this.clearPopupCheck();
          this.loadUserInfo();
        }
      }, 1000);
    },

    // 清除弹窗监听
    clearPopupCheck() {
      if (this.popupCheckTimer) {
        clearInterval(this.popupCheckTimer);
        this.popupCheckTimer = null;
      }
      if (this.authPopup && !this.authPopup.closed) {
        this.authPopup.close();
      }
      this.authPopup = null;
    },

    // 设置消息监听
    setupMessageListener() {
      this.removeMessageListener();
      this.messageHandler = (event) => {
        if (event.origin !== window.location.origin) {
          return;
        }
        if (event.data && event.data.type === 'feishu-auth-code') {
          this.handleBindFeishuCode(event.data.code);
        }
      };
      window.addEventListener('message', this.messageHandler);
    },

    // 处理飞书授权码
    async handleBindFeishuCode(code) {
      try {
        const res = await bindFeishu(code, window.location.origin);
        if (res.code === 200) {
          this.$message.success(this.$t('login.bindSuccess'));
          await this.loadUserInfo();
        } else {
          this.$message.error(res.msg || this.$t('login.bindFailed'));
        }
      } catch (error) {
        console.error('绑定飞书失败:', error);
        this.$message.error(this.$t('login.bindFailed'));
      }
    },

    // 移除消息监听
    removeMessageListener() {
      if (this.messageHandler) {
        window.removeEventListener('message', this.messageHandler);
        this.messageHandler = null;
      }
    },

    // 解绑飞书
    handleUnbindFeishu() {
      this.$refs.unbindFormRef.validate(async(valid) => {
        if (!valid) {
          return false;
        }
        this.unbindLoading = true;
        try {
          const res = await unbindFeishu(this.unbindForm.validaCode);
          if (res.code === 200) {
            this.$message.success(this.$t('login.unbindSuccess'));
            this.unbindDialogVisible = false;
            await this.loadUserInfo();
          } else {
            this.$message.error(res.msg || this.$t('login.unbindFailed'));
          }
        } catch (error) {
          console.error('解绑飞书失败:', error);
          this.$message.error(this.$t('login.unbindFailed'));
        } finally {
          this.unbindLoading = false;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.personal-center-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  min-height: 100vh;
  padding: 24px;

  .personal-center-content {
    max-width: 960px;
    margin: 0 auto;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;

    .user-header {
      display: flex;
      align-items: center;
      padding: 28px 32px;
      background: linear-gradient(135deg, #52c41a 0%, #00A933 100%);
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: -50%;
        right: -10%;
        width: 300px;
        height: 300px;
        background: rgba(255,255,255, 0.1);
        border-radius: 50%;
      }

      &::after {
        content: '';
        position: absolute;
        bottom: -30%;
        right: 20%;
        width: 200px;
        height: 200px;
        background: rgba(255,255,255, 0.08);
        border-radius: 50%;
      }

      .avatar-wrapper {
        position: relative;
        z-index: 1;

        ::v-deep .el-avatar {
          background: #fff;
          color: #52c41a;
          border: 4px solid rgba(255, 255, 255, 0.3);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
      }

      .user-info {
        margin-left: 20px;
        flex: 1;
        position: relative;
        z-index: 1;

        .user-name {
          font-size: 24px;
          font-weight: 700;
          color: #fff;
          margin-bottom: 6px;
          letter-spacing: 0.5px;
        }

        .user-account {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.85);
          margin-bottom: 12px;
        }

        .user-role {
          ::v-deep .el-tag {
            background: rgba(255, 255, 255, 0.2);
            border: 1px solid rgba(255, 255, 255, 0.3);
            color: #fff;
            font-weight: 500;
            backdrop-filter: blur(10px);
          }
        }
      }
    }

    .info-section {
      padding: 32px;

      .section-header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 24px;
        padding-bottom: 16px;
        border-bottom: 2px solid #f0f0f0;

        i {
          font-size: 20px;
          color: #52c41a;
        }

        span {
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
        }
      }

      .info-list {
        .info-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 0;
          border-bottom: 1px solid #f0f0f0;
          transition: all 0.3s ease;

          &:last-child {
            border-bottom: none;
          }

          &:hover {
            .info-label {
              color: #52c41a;
            }
          }

          .info-label {
            font-size: 14px;
            color: #6c757d;
            font-weight: 500;
            flex-shrink: 0;
            width: 120px;
          }

          .info-value {
            font-size: 14px;
            color: #1a1a1a;
            font-weight: 500;
            flex: 1;
            text-align: right;
          }
        }
      }
    }

    .feishu-section {
      padding: 0 32px 32px;

      .section-header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 20px;
        padding-bottom: 16px;
        border-bottom: 2px solid #f0f0f0;

        i {
          font-size: 20px;
          color: #52c41a;
        }

        span {
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
        }
      }

      .feishu-card {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 24px 28px;
        border-radius: 12px;
        border: 2px solid transparent;
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;

        &.bound {
          background: linear-gradient(135deg, #f0f9eb 0%, #e8f5e9 100%);
          border-color: #67c23a;

          .feishu-icon {
            i {
              color: #67c23a;
              background: rgba(103, 194, 58, 0.15);
            }
          }

          .unbind-btn {
            background: #f56c6c;
            border-color: #f56c6c;

            &:hover {
              background: #f78989;
              border-color: #f78989;
            }
          }
        }

        &.unbound {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          border-color: #d9d9d9;

          .feishu-icon {
            i {
              color: #909399;
              background: rgba(144, 147, 153, 0.15);
            }
          }

          .bind-btn {
            background: linear-gradient(135deg, #52c41a 0%, #42b983 100%);
            border: none;

            &:hover {
              background: linear-gradient(135deg, #42b983 0%, #5bc0be 100%);
              transform: translateY(-2px);
              box-shadow: 0 6px 16px rgba(82, 196, 26, 0.3);
            }
          }
        }

        &:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        }

        .feishu-icon {
          flex-shrink: 0;
          width: 56px;
          height: 56px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 20px;

          i {
            font-size: 28px;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .feishu-info {
          flex: 1;

          .feishu-title {
            font-size: 16px;
            font-weight: 600;
            color: #1a1a1a;
            margin-bottom: 6px;
          }

          .feishu-desc {
            font-size: 13px;
            color: #6c757d;
            line-height: 1.5;
          }
        }
      }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}

::v-deep .unbind-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);

  .el-dialog__header {
    padding: 24px 24px 16px;
    border-bottom: 1px solid #f0f0f0;
    margin: 0;

    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: #1a1a1a;
    }

    .el-dialog__close {
      font-size: 20px;
      color: #909399;
      transition: color 0.3s;

      &:hover {
        color: #00A551;
      }
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 16px 24px 24px;
    border-top: 1px solid #f0f0f0;
  }
}

.unbind-dialog-content {
  .unbind-warning {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px;
    background: linear-gradient(135deg, #fff7e6 0%, #ffeecf 100%);
    border-radius: 8px;
    border: 1px solid #ffd591;
    margin-bottom: 20px;

    i {
      font-size: 20px;
      color: #fa8c16;
    }

    span {
      font-size: 14px;
      color: #874d00;
      line-height: 1.5;
    }
  }

  .el-form {
    .el-form-item__label {
      font-size: 14px;
      font-weight: 500;
      color: #303133;
      padding-bottom: 8px;
    }

    .code-input {
      .el-input__inner {
        height: 44px;
        border-radius: 8px;
        border: 1px solid #d9d9d9;
        font-size: 14px;
        transition: all 0.3s;

        &:hover {
          border-color: #00A551;
        }

        &:focus {
          border-color: #00A551;
          box-shadow: 0 0 0 3px rgba(0, 165, 81, 0.1);
        }
      }

      .el-input-group__append {
        border-radius: 0 8px 8px 0;
        border-left: 1px solid #d9d9d9;
        background: #f5f7fa;
        padding: 0;
        overflow: hidden;
      }
    }

    .send-code-btn {
      border: none;
      background: transparent;
      color: #00A551;
      font-size: 14px;
      padding: 0 16px;
      height: 100%;
      border-radius: 0;
      transition: all 0.3s;

      &:hover:not(:disabled) {
        background: rgba(0, 165, 81, 0.1);
        color: #12B866;
      }

      &:disabled {
        color: #c0c4cc;
      }
    }
  }
}

.dialog-footer {
  .cancel-btn {
    height: 40px;
    padding: 0 24px;
    border-radius: 8px;
    border: 1px solid #d9d9d9;
    background: #fff;
    color: #606266;
    font-size: 14px;
    transition: all 0.3s;

    &:hover {
      border-color: #00A551;
      color: #00A551;
      background: rgba(0, 165, 81, 0.05);
    }
  }

  .confirm-btn {
    height: 40px;
    padding: 0 24px;
    border-radius: 8px;
    background: linear-gradient(135deg, #00A551 0%, #12B866 100%);
    border: none;
    font-size: 14px;
    transition: all 0.3s;

    &:hover:not(:disabled) {
      background: linear-gradient(135deg, #12B866 0%, #36C978 100%);
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 165, 81, 0.35);
    }

    &:active:not(:disabled) {
      transform: translateY(0);
    }

    &:disabled {
      background: #c0c4cc;
    }
  }
}
</style>
